// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.node {\n  cursor: pointer;\n}\n.link {\n  fill: none;\n  stroke: #ccc;\n  stroke-width: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
